export const BRAND_NAVY = '#12122B';
export const BRAND_ORANGE = '#F7941F';
export const BRAND_RED = '#FF4747';
